import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featured = getTrendingArticles(1)[0];
  const topArticles = getTrendingArticles(5).slice(0, 4);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dramatic%20dark%20abstract%20background%20with%20warm%20crimson%20and%20deep%20charcoal%20color%20gradient%2C%20newspaper%20headline%20breaking%20news%20concept%2C%20atmospheric%20moody%20lighting%2C%20cinematic%20composition%2C%20minimalist%20yet%20dramatic%2C%20no%20people%2C%20abstract%20journalism%20theme&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="爆料网 - 最新吃瓜黑料曝光"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="爆料网 - 最新吃瓜黑料曝光汇总"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20">
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-2/3">
            <Link to={`/article/${featured.id}`} className="block group cursor-pointer">
              <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-label rounded-full mb-4 whitespace-nowrap">
                今日重磅
              </span>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4 leading-tight group-hover:text-accent-300 transition-colors">
                {featured.title}
              </h1>
              <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-2xl mb-6">
                {featured.excerpt}
              </p>
              <div className="flex items-center gap-4 text-xs text-background-300 font-label">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> {featured.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i> {new Date(featured.publishedAt).toLocaleDateString('zh-CN')}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {(featured.views / 10000).toFixed(0)}万阅读
                </span>
              </div>
            </Link>
          </div>

          <div className="lg:w-1/3 flex flex-col gap-3">
            {topArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex items-start gap-3 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all cursor-pointer group"
              >
                <span className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold font-label">
                  {idx + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm text-white font-label font-medium leading-snug group-hover:text-accent-300 transition-colors line-clamp-2">
                    {article.title}
                  </p>
                  <span className="text-xs text-background-400 mt-1 inline-block whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}